import { connect } from 'react-redux'
import type moment from 'moment'
import { showFlexibleCancellation, showFreeCancellation } from 'lib/offer/cancellationPolicyUtils'
import OfferPropertyCancellationPolicies from 'components/Common/CancellationPolicies/Flash/OfferPropertyCancellationPolicies'
import OfferPropertyFlexibleCancellationPolicies from 'components/Common/CancellationPolicies/Flash/OfferPropertyFlexibleCancellationPolicies'
import OfferPropertyNonRefundablePolicy from './OfferPropertyNonRefundablePolicy'
interface Props {
  offerId?: string
  uniqueKey?: string
  propertyTimezoneOffset?: number
  cancellationPolicy?: App.OfferCancellationPolicy
  checkInDate?: string | moment.Moment
  cancellationReferenceDate?: string | moment.Moment
  isChangePackage?: boolean
  isFlashUSP?: boolean
}

function FlashCancellationPolicies(props: Props) {
  const { cancellationPolicy, checkInDate, cancellationReferenceDate, propertyTimezoneOffset, isChangePackage, isFlashUSP } = props
  const policyReferenceDate = cancellationReferenceDate ?? checkInDate
  const freeCancellation = showFreeCancellation(policyReferenceDate, isChangePackage, cancellationPolicy)
  const flexibleCancellation = showFlexibleCancellation(policyReferenceDate, isChangePackage, cancellationPolicy)
  const refundable = freeCancellation || flexibleCancellation
  return (
    <>
      {freeCancellation && <OfferPropertyCancellationPolicies
        propertyTimezoneOffset={propertyTimezoneOffset}
        checkInDate={policyReferenceDate}
        isFlashUSP={isFlashUSP}
      />}
      {flexibleCancellation && <OfferPropertyFlexibleCancellationPolicies
        cancellationPolicy={cancellationPolicy!}
        propertyTimezoneOffset={propertyTimezoneOffset}
        checkInDate={policyReferenceDate}
        isFlashUSP={isFlashUSP}
      />}
      {(!refundable && cancellationPolicy?.type !== 'hidden-cancellation-policy') && <OfferPropertyNonRefundablePolicy />}
    </>
  )
}

function mapStateToProps(state: App.State, ownProps: Partial<Props>) {
  const offer = state.offer.offers[ownProps.offerId ?? '']
  const pkg = offer?.packages.find(pkg => pkg.uniqueKey === ownProps.uniqueKey)

  return {
    cancellationPolicy: ownProps.cancellationPolicy || pkg?.roomRate?.cancellationPolicy,
  }
}

export default connect(mapStateToProps)(FlashCancellationPolicies)
